export const SET_NEWS_DIGESTS_FETCHING = 'SET_NEWS_DIGESTS_FETCHING';
export const SET_NEWS_DIGESTS = 'SET_NEWS_DIGESTS';
export const SET_NEWS_DIGESTS_ERROR = 'SET_NEWS_DIGESTS_ERROR';
export const CLEAN_NEWS_DIGESTS = 'CLEAN_NEWS_DIGESTS';
export const ABORT_NEWS_DIGESTS_REQUEST = 'ABORT_NEWS_DIGESTS_REQUEST';
export const RESET_NEWS_DIGESTS_FETCHING = 'RESET_NEWS_DIGESTS_FETCHING';
export const NEWS_DIGESTS_CHANGE_DISPLAY = 'NEWS_DIGESTS_CHANGE_DISPLAY';



// WEBPACK FOOTER //
// ./src/redux_related/newsDigests/actions.js